import StakeholderEditFormActionButtonsWidgetContainer from "./edit/StakeholderEditFormActionButtonsWidgetContainer"
import StakeholderEditItemContainer from "./edit/StakeholderEditItemContainer"
import StakeholderViewFormActionButtonsWidgetContainer from "./view/StakeholderViewFormActionButtonsWidgetContainer"
import StakeholderViewItemContainer from "./view/StakeholderViewItemContainer"
import buildItemComponent from "../../common/item-component-hoc"

const Stakeholder = buildItemComponent("stakeholders", {
    view: [StakeholderViewFormActionButtonsWidgetContainer, StakeholderViewItemContainer],
    edit: [StakeholderEditFormActionButtonsWidgetContainer, StakeholderEditItemContainer]
})

export default Stakeholder
